import { Component, inject, OnInit, signal } from '@angular/core';
import { BoardService } from '../board.service';
import { PageHeaderComponent } from '@shared/components/page-header/page-header.component';
import { NextAppointmentComponent } from '../components/next-appointment/next-appointment.component';
import { DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  templateUrl: 'board-dashboard.component.html',
  imports: [
    PageHeaderComponent,
    NextAppointmentComponent,
    MatIcon,
    MatButton,
    RouterLink,
    DatePipe,
    TranslateModule,
  ],
})
export class BoardDashboardComponent implements OnInit {
  private boardService = inject(BoardService);

  public numberMinutes = signal<number | null>(null);
  public lastDate = signal<string | null>(null);

  ngOnInit(): any {
    this.boardService.getMeetingMinutes().subscribe(minutes => {
      if (minutes && minutes.length) {
        this.numberMinutes.set(minutes.length);
        this.lastDate.set(minutes[0].date.slice(0, 10));
      }
    });
  }
}
